
import React from "react";
import { Form, Input, ConfigProvider } from 'antd';
const { TextArea } = Input;
const InputField = ({ label, name, placeholder, req = true, maxLength, inputType, disabled,rules=[]  }) => (
    <ConfigProvider direction="rtl">
        <Form.Item name={name} label={label} labelCol={{ span: 24 }}
            rules={[
                {
                    required: req,
                    message: `لطفا ${label} خود را وارد نمایید!`,
                },
            ].concat(rules)}
        >
            {(inputType !== 'TextArea') ?
                <Input placeholder={placeholder} maxLength={maxLength} autoComplete="off" disabled={disabled} /> :
                <TextArea rows={4} placeholder={placeholder} maxLength={maxLength} />
            }
        </Form.Item>
    </ConfigProvider>
);

export default InputField;